import React from "react";
import { ContactContent } from "../../components/ContactContent/ContactContent";
import { NextButton } from "../../components/NextButton/NextButton";
const Contact = () => {
  return (
    <>
      <ContactContent />
      <NextButton nextRoute="/" />
    </>
  );
};

export default Contact;
